import { DialogTitle, Stack } from "@mui/material"
import { BoundTextField } from "lib/@components/binding/bound-components"
import { DataInputDialog } from "lib/@dialogs/data-input-dialog"

export function EditRegisterDescriptionDialog({ source }) {
    return (
        <DataInputDialog initialValue={source}>
            <DialogTitle sx={{ mb: 3 }}>Edit Asset Register Description</DialogTitle>

            <Stack spacing={2} sx={{ mx: 3 }}>
                <BoundTextField
                    autoFocus
                    field="description"
                    multiline
                    minRows={4}
                    inputProps={{ maxLength: 500, "data-cy": "register-description-input" }}
                    transformOut={trimStart}
                    transformOutOnBlur={trimStart}
                    updateValueOnBlur={false}
                    yup="string.trim.notRequired.matches(/^[^<>]*$/, 'These characters are not allowed').matches(/^(?:$|.{5,})$/, 'At least 5 characters required')"
                />
            </Stack>
        </DataInputDialog>
    )

    function trimStart(value) {
        return value === null || value === undefined ? "" : String(value).trimStart()
    }
}
